'use client';

// module imports
import { QRCodeCanvas } from 'qrcode.react';
import { useEffect, useRef, useState } from 'react';

export default function FeedbackQRCode({ eventSlug, title = 'Event QR Code' }: { eventSlug: string; title: string }) {
  const [eventCode] = useState('');
  const [qrUrl, setQrUrl] = useState('');
  const qrRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (eventSlug && typeof window !== 'undefined') {
      const base = `${window.location.origin}/feedback/${eventSlug}`;
      setQrUrl(eventCode ? `${base}/?event=${encodeURIComponent(eventCode)}` : base);
    }
  }, [eventSlug, eventCode]);

  const downloadHandler = () => {
    const canvas = qrRef.current;
    if (!canvas) return;
    const url = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `qr-${eventSlug}${eventCode ? `-${eventCode}` : ''}.png`;
    link.href = url;
    link.click();
  };

  return (
    <div className="space-y-2 sm:space-y-4 mt-4 sm:mt-6 lg:mt-8">
      <div className="flex flex-col items-center">
        <div className="mb-1 font-semibold text-sm sm:text-base lg:text-lg">{title}</div>
        <div className="bg-white p-2 sm:p-3 lg:p-4 rounded shadow mb-2 sm:mb-3 lg:mb-4">
          <QRCodeCanvas ref={qrRef} value={qrUrl} size={120} level="H" className="sm:w-40 sm:h-40 lg:w-40 lg:h-40" />
        </div>
        <button onClick={downloadHandler} className="px-3 sm:px-4 lg:px-6 py-1.5 sm:py-2 bg-gray-200 hover:bg-gray-300 rounded text-xs sm:text-sm cursor-pointer">
          Download QR Code
        </button>
      </div>
      <p className="text-xs sm:text-sm text-gray-500 mb-6 sm:mb-8 lg:mb-10 break-all text-center">
        People will visit: <code className="text-xs sm:text-sm">{qrUrl}</code>
      </p>
    </div>
  );
}
